import styled from "styled-components";
import Styleguide, { Colors, theme } from "../theme";

type ButtonProps = {
  disabled?: boolean;
  width?: string;
  outline?: boolean;
};

export const Button = styled.button<ButtonProps>`
  border-radius: 8px;
  border: solid 1px ${(p) => theme(Colors.blue[100], Colors.white)};
  cursor: pointer;

  font-family: ${Styleguide.fonts.heading.name};
  font-size: ${Styleguide.fontSizes[16]};
  font-weight: ${Styleguide.fontWeights.semibold};
  font-feature-settings: ${Styleguide.fonts.heading.settings};

  text-align: center;
  width: ${(p) => p.width ?? "100%"};
  height: 48px;
  color: ${(p) => theme(Colors.white, Colors.gray[500])};
  background-color: ${(p) =>
    p.outline ? "transparent" : theme(Colors.blue[100], Colors.white)};
  transition: opacity 0.3s;

  @media (min-width: ${Styleguide.breakpoints.desktop}) {
    font-size: ${Styleguide.fontSizes[18]};
  }

  &:hover {
    opacity: 0.8;
  }

  :focus-visible {
    outline-width: 2px;
    outline-style: solid;
    outline-offset: 4px;
    outline-color: ${theme(Colors.blue[100], Colors.lightBlue[100])};
  }

  :disabled {
    background-color: #dddddd;
    border: solid 1px #dddddd;
    cursor: auto;
  }
`;

Button.defaultProps = {
  width: "100%",
};

export const HollowButton = styled(Button)`
  background-color: transparent;
  color: ${(p) => theme(Colors.blue[100], Colors.white)};
`;
